export default {
  path: '/app',
  component: () => import('@/views/app/the-layout.vue'),
  children: [
    {
      path: '/:pathMatch(.*)*',
      component: () => import('@/views/errors/error-404.vue'),
      meta: { title: 'Halaman Tidak Ditemukan' },
    },
  ],
}
